export default __webpack_public_path__ + "logo.f64932e4.svg";